var Marionette = require('backbone.marionette');

var RemoteSuggesterView = require('../common/remote-suggester-input.js');

var CommonUtils = require('../../utils/common-utils.js');

var PhysicianFormView = Marionette.View.extend({
    template: require('../../templates/med-forms/physician-form.html'),

    regions: {
        primaryPhysicianSelect: '#primary-physician-name-select'
    },
    
    ui: {
        primaryPhysicianRelationship: '.primary-physician-rel',
        primaryPhysicianDateOfLastVisit: '.primary-physician-date-of-last-visit',
        remove: '.remove-physician'
    },

    events: {
        'click @ui.remove': 'removePhysician',
        'change @ui.primaryPhysicianRelationship': 'onPrimaryPhysicianRelationshipChanged'
    },

    childViewEvents: {
        'suggestor:selected:physician': 'onSelectPhysician'
    },

    templateContext: function () {
        var that = this;
        return {
            showRemove: this.showRemove == undefined ? true : this.showRemove
        }
    },


    initialize: function (options) {
        if (options) {
            this.physician = options.physician;
            this.regionId = options.regionId;
            this.showRemove = options.showRemove;
        }

        this.utils = new CommonUtils();
    },

    onRender: function () {
        var that = this;

        that.ui.primaryPhysicianDateOfLastVisit.datepicker({
            format: 'mm/dd/yyyy',
            endDate: '+0d',
            clearBtn: true
        }).on('changeDate', function (e) {
            $(this).datepicker('hide');
            that.physician.dateOfLastVisit = that.utils.dateToLong(e.target.value);
        }).on('clearDate', function(e) {
            that.physician.dateOfLastVisit = 0;
        });

        that.showPrimaryPhysicianSelect();
    },

    onPrimaryPhysicianRelationshipChanged: function (event) {
        this.physician.relationship = event.target.value;
    },

    onSelectPhysician: function (selected) {
        this.physician.name = selected;
    },

    showPrimaryPhysicianSelect: function () {
        var that = this;

        var nameRetriever = function (item) {
            if (_.isUndefined(item) || _.isNull(item))
                return '';

            return item.basic["last_name"] + ' ' + item.basic["first_name"]
                + ' (' + item.number + ')'
        };

        that.showChildView('primaryPhysicianSelect', new RemoteSuggesterView({
            tag: 'physician',
            //inputId: that.regionId + '-input',
            requestDelay: 5000,
            maxNumberOfElements: 200,
            url: '/api/npi/person/like?nameOrNpi=~~~',
            symbolForSearchInUrl: '~~~',
            listLocation: function (data) {
                return data;
            },
            getValueFn: function (element) {
                return nameRetriever(element);
            },
            classes: ["form-control"],
            placeholder: "Type NPI or names (first and last) part splitted with space",
            findSelectedIdBySelectedIndex: function (arr, index) {
                return nameRetriever(arr[index]) || null;
            }
        }));
    },

    removePhysician: function () {
        var that = this;
        that.triggerMethod('physician:remove', {regionId: that.regionId, physician: that.physician});
    }
});

module.exports = PhysicianFormView;


//////////////////
// WEBPACK FOOTER
// ./app/views/med-forms/physician-form.js
// module id = 515
// module chunks = 0